var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNormasSeguridad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#GradientFill_3-2);\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#GradientFill_3);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3",
    "data-name": "GradientFill 3",
    x1: 25,
    y1: 50.16,
    x2: 25,
    y2: 0.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa780c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#d1b24a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5d06a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-2",
    "data-name": "GradientFill 3",
    x1: 25.34,
    x2: 25.34,
    xlinkHref: "#GradientFill_3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25,3.06C12.9,3.06,3.06,12.9,3.06,25s9.84,21.94,21.94,21.94,21.94-9.84,21.94-21.94S37.1,3.06,25,3.06M25,50C11.21,50,0,38.79,0,25S11.21,0,25,0s25,11.21,25,25-11.21,25-25,25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.37,38.57c-1.68,0-3.04-1.36-3.04-3.04v-13.24l5.04-11.32h2.4v4.39c0,2.43,1.74,4.47,4.04,4.92v4.84h-8.44v1.97h8.44v4.76h-8.44v1.97h8.44v4.75h-8.44ZM21.31,38.57h-8.44v-4.75h8.44v-1.97h-8.44v-4.76h8.44v-1.97h-8.44v-4.84c.96-.19,1.85-.66,2.56-1.36.95-.94,1.48-2.2,1.48-3.56v-4.39h2.4l5.03,11.32v13.24c0,1.68-1.36,3.04-3.04,3.04M29.2,10.97l-3.86,8.69-3.86-8.69h7.73ZM38.77,18.41c-1.67,0-3.03-1.37-3.03-3.04v-6.37H14.95v6.38c0,.81-.32,1.58-.9,2.15-.57.57-1.34.88-2.14.88h-1s0,22.14,0,22.14h10.41c1.65,0,3.11-.8,4.03-2.03.91,1.23,2.38,2.03,4.03,2.03h10.41v-22.18l-1.01.04Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNormasSeguridad);
export default __webpack_public_path__ + "static/media/Icon_NormasSeguridad.9d62993104803073e1f95e4808bdcd11.svg";
export { ForwardRef as ReactComponent };